import { adminEventRows, DataTable, LivePanel, useViewModel } from "@lumora/ui";
import { useCallback, useMemo } from "react";
import { useSiteOpsVm } from "./platformViewModels.js";
import { PlatformPageHeader } from "./PlatformPageHeader.js";

export function PlatformActivityPage() {
  const vm = useSiteOpsVm();
  const { events } = useViewModel(vm);
  const load = useCallback(() => vm.loadEvents(200), [vm]);

  const rows = useMemo(() => adminEventRows(events), [events]);

  return (
    <div className="site-platform">
      <PlatformPageHeader
        title="Activity"
        lead="REST audit trail for orders, checkouts, and admin actions."
      />
      <LivePanel title="Platform events" load={load} intervalMs={3000}>
        <DataTable columns={["Type", "Message", "When"]} rows={rows} empty="No activity yet." />
      </LivePanel>
    </div>
  );
}
